import { Component, inject, Input, OnInit } from '@angular/core';
import { BaseModalComponent } from '@card-software/library';
import { EnumValues } from '@card-software/library';
import { ProductionCardClosePreview } from '@app/models/production/production-card';
import { EnumService } from '@app/services/enum.service';
import { LocationPathService } from '@app/services/location-path.service';

@Component({
  selector: 'app-close-production-card-modal',
  templateUrl: './close-production-card-modal.component.html',
  styleUrl: './close-production-card-modal.component.scss',
})
export class CloseProductionCardModalComponent extends BaseModalComponent<boolean> implements OnInit {
  private readonly enumService = inject(EnumService);
  readonly locationPathService = inject(LocationPathService);

  @Input() closePreview!: ProductionCardClosePreview;
  @Input() productionCardNumber = '';

  fabricFormValues: EnumValues = {};

  ngOnInit(): void {
    this.fabricFormValues = this.enumService.getEnum('FabricForm', 'itemEnums')?.values || {};
    this.locationPathService.load((this.closePreview?.rollsForProcessLoss ?? []).map((roll) => roll.currentLocation?.code));
  }

  getFabricFormLabel(fabricForm: number | null): string {
    if (fabricForm === null || fabricForm === undefined) return '';
    return this.fabricFormValues?.[fabricForm] ?? '';
  }

  onConfirm(): void {
    this.close({ action: 'save', data: true });
  }

  onCancel(): void {
    this.close({ action: 'close', data: false });
  }
}
